import MatchAccaSelectionItem from 'modules/match-acca/match-acca-selection-item';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';
import BetslipModuleUtils from 'modules/betslip/utils.js';
import Odds from 'modules/betslip/betslip-view/bet-components/odds/index.js';
import BetErrors from 'modules/betslip/betslip-view/bet-components/bet-errors/index.js';
import withSportBetStake from 'modules/betslip/betslip-view/stake-input-hoc/index.js';
import StakeInputView from 'modules/stake-input/index.js';
import RemoveSelection from 'modules/betslip/betslip-view/bet-components/remove-selection/index.js';

const StakeInput = withSportBetStake(StakeInputView);
const { utils: BetslipUtils, types: BetslipTypes } = MojitoServices.Betslip;
const { Text, FlexPane, Image } = MojitoPresentation.Components;
const { BET_BUILDER_NON_COMBINABLE, BET_BUILDER_REDUNDANT_SELECTION } = BetslipTypes.ERROR_CODE;

const allowedBetBuilderErrorCodes = [BET_BUILDER_NON_COMBINABLE, BET_BUILDER_REDUNDANT_SELECTION];

const MatchAccaBetContent = props => {
    const {
        hasOddsChange,
        mojitoTools: { stringResolver, config, l10n },
        suspended,
        expired,
        bet,
        betslip,
        hasHcapChange,
        betStake,
        showEachWay,
        showStake,
        onStakeInputFocus,
        isBetEachWay,
        cbRemoveBet,
        suspendedParts,
    } = props;

    const { stake = 0, freebetStake = 0, errors: stakeErrors = [] } = betStake;

    // Since Match Acca is for one event, pick event name from any bet part.
    const eventName = bet.parts[0].partInfo.eventName;
    const suspendedSuffix = suspended ? 'Suspended' : '';
    const isBoostedBetBuilderBet = !!bet.baseOdds;
    const betBuilderErrors = BetslipUtils.getErrorsByBetId(betslip, bet.id).filter(({ code }) =>
        allowedBetBuilderErrorCodes.includes(code)
    );
    const errors = betBuilderErrors.concat(
        BetslipModuleUtils.getBetErrors(betStake, hasHcapChange)
    );
    const hasBetBuilderError = betBuilderErrors.length > 0;

    const headerTitle = isBoostedBetBuilderBet
        ? stringResolver.resolveString('$BETSLIP.MATCH_ACCA.BOOSTED_BET_HEADER')
        : stringResolver.resolveString('$BETSLIP.MATCH_ACCA.BET_HEADER');

    return (
        <>
            <FlexPane config={config.betslipBet.betInfoContainer} class={'ta-MatchAccaBetContent'}>
                <RemoveSelection
                    config={config.removeSelection}
                    bet={bet}
                    cbRemoveBet={cbRemoveBet}
                />
                <FlexPane config={config.infoContainer}>
                    <FlexPane config={config.betslipBet.matchAccaHeaderContainer}>
                        <Image config={config.betslipBet.matchAccaImage} class="ta-MatchAccaIcon" />
                        <Text config={config.betslipBet[`matchAccaHeader${suspendedSuffix}`]}>
                            {headerTitle}
                        </Text>
                        <Odds
                            bet={bet}
                            config={config.odds}
                            hasOddsChange={hasOddsChange}
                            suspended={suspended}
                            expired={expired}
                        />
                    </FlexPane>
                    <Text
                        config={config.betslipBet[`matchAccaEventName${suspendedSuffix}`]}
                        class={'ta-eventName'}
                    >
                        {eventName}
                    </Text>
                    <FlexPane
                        config={config.betslipBet.matchAccaSelectionsContainer}
                        class={'ta-selectionsContainer'}
                    >
                        <MatchAccaSelections
                            l10n={l10n}
                            bet={bet}
                            suspendedParts={suspendedParts}
                            config={config.matchAccaSelectionItem}
                        />
                    </FlexPane>
                </FlexPane>
            </FlexPane>
            <BetErrors config={config.betErrors} errors={errors} />
            {!suspended && !expired && showStake && !hasBetBuilderError && (
                <StakeInput
                    config={config.stakeInput}
                    betId={bet.id}
                    stakeForLine={stake || freebetStake}
                    isEachWayAvailable={showEachWay}
                    isEachWayActivated={isBetEachWay}
                    showStake={true}
                    isValid={stakeErrors.length === 0}
                    onFocusCallback={onStakeInputFocus}
                />
            )}
        </>
    );
};

const MatchAccaSelections = ({ bet, l10n, suspendedParts, config }) => {
    const isBetBuilderBet = BetslipUtils.isBetBuilderBet(bet);
    const isBetBuilderBetFixed = BetslipUtils.isBetBuilderBetFixed(bet);
    return bet.parts.map((part, i, row) => {
        const showSeparator = i + 1 !== row.length;
        const selectionLabel = BetslipModuleUtils.resolveNameAndHandicapLabel(part, l10n);
        const { isSuspended } = suspendedParts[part.selectionId] || {};

        return (
            <MatchAccaSelectionItem
                config={config}
                isSuspended={isSuspended}
                key={part.selectionId}
                selectionId={part.selectionId}
                showSeparator={showSeparator}
                selectionLabel={selectionLabel}
                marketName={part.partInfo.marketName}
                earlyPayout={part.earlyPayout}
                isRedundant={part.isRedundant}
                allowSelectionRemoval={!isBetBuilderBetFixed && isBetBuilderBet}
            />
        );
    });
};

export default MatchAccaBetContent;
